export const IMAGE_PATH = {
  DEFAULT_USER: '/images/ui/icons/default_user_icon.svg',
} as const;
// TODO: タイミングを見て定数オブジェクトに混ぜる
export const DEFAULT_IMAGE_PATH = '/images/shared/default-image.svg' as const;
export const DEFAULT_EVENT_IMAGE_PATH = '/images/shared/default-event-image.svg' as const;
